import {initializeBrowserBugReporting} from "tensorbuzz-api/build/bug-reporting/browser-reporter.js"
import SourceMapsLoader from "tensorbuzz-api/build/bug-reporting/source-maps-loader.js"

const reporters = new WeakMap()

// Host glue for tensorbuzz-api's initializeBrowserBugReporting: the layout
// injects the configuration on the window, and Nemoa symbolicates stack
// frames only (script-tag maps stay out of scope). Optional SourceMapsLoader
// constructor options are passed through for host-level tuning.
export default function initializeBugReporting(browser, sourceMapsLoaderOptions = {}) {
  if (reporters.has(browser)) return reporters.get(browser)

  const reporter = initializeBrowserBugReporting({
    browser,
    configuration: browser.tensorBuzzBugReporting,
    sourceMapsLoader: new SourceMapsLoader({browser, loadScriptTagMaps: false, ...sourceMapsLoaderOptions})
  })

  if (!reporter) return undefined

  const initialized = {
    report: reporter.report,
    disconnect() {
      reporter.disconnect()
      reporters.delete(browser)
    }
  }

  reporters.set(browser, initialized)

  return initialized
}
